/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_No_Changes_To_Save_ToastInputs */

const en_knp_lookup_no_changes_to_save_toast = /** @type {(inputs: Knp_Lookup_No_Changes_To_Save_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changes to save`)
};

const fr_knp_lookup_no_changes_to_save_toast = /** @type {(inputs: Knp_Lookup_No_Changes_To_Save_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun changement a enregistrer`)
};

const de_knp_lookup_no_changes_to_save_toast = /** @type {(inputs: Knp_Lookup_No_Changes_To_Save_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Änderungen zum Speichern`)
};

const it_knp_lookup_no_changes_to_save_toast = /** @type {(inputs: Knp_Lookup_No_Changes_To_Save_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna modifica da salvare`)
};

const ru_knp_lookup_no_changes_to_save_toast = /** @type {(inputs: Knp_Lookup_No_Changes_To_Save_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменений для сохранения нет.`)
};

const es_knp_lookup_no_changes_to_save_toast = /** @type {(inputs: Knp_Lookup_No_Changes_To_Save_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay cambios para guardar`)
};

const zh_cn2_knp_lookup_no_changes_to_save_toast = /** @type {(inputs: Knp_Lookup_No_Changes_To_Save_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需保存任何更改`)
};

const ja_knp_lookup_no_changes_to_save_toast = /** @type {(inputs: Knp_Lookup_No_Changes_To_Save_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存する変更はありません`)
};

const hi_knp_lookup_no_changes_to_save_toast = /** @type {(inputs: Knp_Lookup_No_Changes_To_Save_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई बदलाव सहेजने के लिए नहीं हैं`)
};

const pt_pt2_knp_lookup_no_changes_to_save_toast = /** @type {(inputs: Knp_Lookup_No_Changes_To_Save_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma alteração para salvar`)
};

/**
* | output |
* | --- |
* | "No changes to save" |
*
* @param {Knp_Lookup_No_Changes_To_Save_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_no_changes_to_save_toast = /** @type {((inputs?: Knp_Lookup_No_Changes_To_Save_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_No_Changes_To_Save_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_no_changes_to_save_toast(inputs)
	if (locale === "de") return de_knp_lookup_no_changes_to_save_toast(inputs)
	if (locale === "it") return it_knp_lookup_no_changes_to_save_toast(inputs)
	if (locale === "ru") return ru_knp_lookup_no_changes_to_save_toast(inputs)
	if (locale === "es") return es_knp_lookup_no_changes_to_save_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_no_changes_to_save_toast(inputs)
	if (locale === "ja") return ja_knp_lookup_no_changes_to_save_toast(inputs)
	if (locale === "hi") return hi_knp_lookup_no_changes_to_save_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_no_changes_to_save_toast(inputs)
	return en_knp_lookup_no_changes_to_save_toast(inputs)
});